<template>
  <div>
    <Navbar />
    <div class="sheet">
      <h1>Dla lekarzy</h1>
    <p>
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.
Lorem ipsum dolor sit amet, consectetur adipisicing elit.
Error doloremque omnis animi, eligendi magni a voluptatum, vitae, consequuntur rerum illum odit
fugit assumenda rem dolores inventore iste reprehenderit maxime! Iusto.

        </p>
    </div>
  
</div>
</template>
<script>
import Navbar from '../components/Navbar'
export default {
  components: {
    Navbar
  }
}
</script>
<style lang="scss">
@import '../vars.scss';

  .sheet{
    width:60%;
    margin: 20vh auto 2em auto;
    padding:1em;
    background: $gray;

    p{
      font-size:1.1em;
      line-height:1.8em;
    }
  }
</style>
